function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.1846 12.44C15.1804 11.14 15.79 9.52 15.79 7.76C15.79 3.48 12.2337 0 7.88484 0C3.53599 0 0 3.48 0 7.76C0 12.04 3.53599 15.52 7.88484 15.52C9.51058 15.52 11.0347 15.02 12.2947 14.18C12.315 14.2 12.315 14.2 12.3353 14.22L15.79 17.62C16.0339 17.86 16.3793 18 16.7045 18C17.0296 18 17.3751 17.88 17.619 17.62C18.127 17.12 18.127 16.32 17.619 15.82L14.1846 12.44ZM7.84197 12.7C5.08335 12.7 2.84197 10.4586 2.84197 7.69995C2.84197 4.94133 5.08335 2.69995 7.84197 2.69995C10.6006 2.69995 12.842 4.94133 12.842 7.69995C12.842 10.4586 10.6006 12.7 7.84197 12.7Z",
  fill: "#C0C6CD"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/search.56fbf2e4.svg";
export { ForwardRef as ReactComponent };